// extracted by mini-css-extract-plugin
module.exports = {"arrow":"idt-animation_arrow__27yy8","bounce":"idt-animation_bounce__13pbx"};